<template>
  <div>
    <div v-if="value['type'] === 'smartphone'">
      <div>
        <selector
          @input="setProduct"
          :title="`Выберите товар`"
          :titleKey="`select_variant`"
          :prefix="`select_variant`"
          :modal="`variant`"
          :selectKey="`name`"
        />
      </div>
      <div>
        <fg-input
          :readonly="true"
          type="text"
          :label="'Модель смартфона'"
          :labelKey="'model'"
          v-model="value['type_object']['model']"
        />
      </div>
      <div>
        <fg-input
          type="text"
          :label="'Производитель смартфона'"
          :labelKey="'vendor_phone'"
          v-model="value['type_object']['vendor']"
        />
      </div>
      <div>
        <fg-input
          :readonly="true"
          type="text"
          :label="'Серийный номер смартфона'"
          :labelKey="'serial'"
          v-model="value['type_object']['serial']"
        />
      </div>
      <div>
        <fg-input
          type="number"
          :label="'price'"
          :labelKey="'price'"
          v-model="value.price"
        />
      </div>
      <div>
        <fg-input
          type="date"
          :label="'Дата покупки'"
          :labelKey="'date_paid'"
          v-model="value.date_paid"
        />
      </div>
    </div>

    <button class="btn btn-info mw" @click="apply">
      {{ "apply" | setText("Применить") }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: {},
    },
  },
  methods: {
    setProduct(val) {
      this.value["price"] = val.stock.price;
      this.value["type_object"]["model"] = val.name;
      this.value["type_object"]["serial"] = val.barcode;
      this.value["type_object"]["vendor"] =
        val.product && val.product.brand ? val.product.brand.name : "";
    },
    apply() {
      if (
        this.value["type"] === "smartphone" &&
        (!this.value["price"] ||
          !this.value["date_paid"] ||
          !this.value["type_object"]["model"] ||
          !this.value["type_object"]["serial"] ||
          !this.value["type_object"]["vendor"])
      ) {
        this.$notify({
          title: "APEX",
          message:
            "Заполните все поля (модель, производитель, баркод, цена, дата покупки)",
          icon: "ti-info",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "warning",
        });

        return false;
      }

      this.$emit("input", this.value);
    },
  },
  created() {
    if (this.value["type"] === "smartphone") {
      this.value["type_object"] = {
        model:
          this.value["type_object"] && this.value["type_object"]["model"]
            ? this.value["type_object"]["model"]
            : null,
        vendor:
          this.value["type_object"] && this.value["type_object"]["vendor"]
            ? this.value["type_object"]["vendor"]
            : null,
        serial:
          this.value["type_object"] && this.value["type_object"]["serial"]
            ? this.value["type_object"]["serial"]
            : null,
      };
    }
  },
  // data() {
  //   return {
  //     data: {
  //       price: this.value.price,
  //       date_paid: this.value.date_paid,
  //       type_object:
  //         this.value.type_object && this.value.type_object != "null"
  //           ? this.value.type_object
  //           : {
  //               model: null,
  //               vendor: null,
  //               serial: null,
  //             },
  //       type: this.value.type,
  //     },
  //   };
  // },
};
</script>